<template>
  <div class="xm-order-detail">
    <div class="detail-container">
      <pay-status />
      <pay-way
        :order-info="detail"
        v-if="isShowPayWay"
      /> 
      <order-summary />
      <package-and-service
        :product-list="productList"
      >
        <h2
          slot="header"
          v-t="'message.productAndService'"
        />
      </package-and-service>
      <!-- <invoice-and-post /> -->
    </div>
    <order-action />
  </div>
</template>
<script>
  import { mapState,mapGetters, mapActions } from 'vuex'
  import flatten from 'lodash.flatten'
  import { ORDER_SET_ID } from '@store/mutationTypes'
  import {
    ORDER_STATUS_COMPLETE,
    ORDER_TYPE_UPGRADE,
   } from '@utils/constants'
  import Store from '@store'
  import PayStatus from './components/PayStatus'
  import PayWay from './components/PayWay'
  import OrderSummary from './components/OrderSummary'
  import PackageAndService from '@/components/PackageAndService'
  import OrderAction from './components/OrderAction'

  export default {
    name: 'XMOrderDetail',
    async beforeRouteEnter (to, form, next) {
      const id = to.params.id
      Store.commit(`order/${ORDER_SET_ID}`, id)
      const fetchDetail = Store.dispatch('order/fetchOrderDetail')
      const fetchInvoice = Store.dispatch('order/fetchInvoice')
      await fetchDetail
      await fetchInvoice
      next()
    },
    data() {
      return {
        productList: [],
      }
    },
    computed: {
      ...mapState('order', {
        detail: state => state.detail,
      }),
      ...mapGetters('main', ['aliOrderInvoiceHide', 'isAliUser']),
      isShowPayWay () {
        // 已完成订单不显示支付方式
        return this.detail.status != ORDER_STATUS_COMPLETE
      },
    },
    watch: {
      detail: {
        handler () {
          let result = [...this.detail.product_list]
          // 升级订单需将所有合同段合并
          const isUpgradeOrder = this.detail.type == ORDER_TYPE_UPGRADE
          if (isUpgradeOrder) {
            // 所有升级合同段
            const allRefer = result.map(item => item.refer_ids_info)
            // 合同段合并取product_list的第一做渲染
            const product = result[0]
            product.refer_ids_info = flatten(allRefer)
            // 价格取订单总价
            product.amount = this.detail.amount
            product.original_amount = this.detail.original_amount
            result = [product]
          }
          this.productList = result
        },
        immediate: true
      }
    },
    async mounted () {
      this.initRender()
      this.getServerDate()
    },
    methods: {
      ...mapActions('main', ['getServerDate']),
      initRender () {
        // 动态计算class为 text-label标签的宽度
        const $textLabel = document.querySelectorAll('.text-label')
        let max = 0
        $textLabel.forEach(ele => {
          max = Math.max(max, ele.getBoundingClientRect().width)
        })
        $textLabel.forEach(ele => ele.style.width = `${max}px`)
      },
    },
    components: {
      PayStatus,
      PayWay,
      OrderSummary,
      PackageAndService,
      OrderAction
    }
  }
</script>
<style lang="scss" scoped>
  .xm-order-detail{
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    background: #fff;
    h1{
      margin-bottom: 10px;
    }
  }
  .detail-container{
    padding: 0 40px;
    @include layout--mobile{
      padding: 0 20px;
    }
  }
</style>
<style lang="scss">
  .xm-order-detail{
    .title-sub{
      margin-left: 0.8em;
      font-size: 12px;
      font-style: normal;
      color: #909090;
    }
    @include layout--mobile{
      display: flex;
      flex-direction: column;
      .title-sub{
        display: block;
        margin-top: .5em;
        margin-left: 0;
      }
    }
  }
  .download-link{
    display: flex;
    align-items: center;
    margin-left: 1em;
  }
</style>


